import { provide } from 'vue';
import { AUTH_KEY, type UseAuth } from '@/shared/stores/auth';
import { setupAuthInterceptor } from '@/shared/api/client';
import { authStore } from './store';

/**
 * 認証情報をprovideする
 *
 * App.vueで呼び出し、アプリケーション全体でuseAuth()を使えるようにする。
 * 読み取り専用のインターフェースのみをprovideする。
 *
 * 注意: initializeAuth()はmain.tsでapp.use(router)より前に呼び出す必要がある。
 * authGuardがルーター初期化時に実行されるため、その前にトークンを復元しておく必要がある。
 */
export const provideAuth = (): void => {
    // main.tsで既に呼び出し済み（authGuardより先に実行する必要があるため）
    // 冪等な処理なので、安全のため再度呼び出しても問題ない
    authStore.initializeAuth();

    const auth: UseAuth = {
        user: authStore.user,
        isAuthenticated: authStore.isAuthenticated,
        role: authStore.role,
        getAccessToken: authStore.getAccessToken,
        getRefreshToken: authStore.getRefreshToken,
    };

    provide(AUTH_KEY, auth);
};

export const initializeAuthInterceptor = (): void => {
    setupAuthInterceptor({
        getAccessToken: authStore.getAccessToken,
        getRefreshToken: authStore.getRefreshToken,
        updateTokens: authStore.updateTokens,
        clearAuth: authStore.clearAuth,
    });
};

export { authStore } from './store';
